import React from 'react';
import { isFlashPromotion } from 'domains/promotion/Promotion.types';
import { Flex } from 'UI';
import { ByReferencesProps } from './AddPromotedReferece';
import { ApplyDiscountCommercialFamily } from './ApplyDiscountCommercialFamily';
import { CommercialFamilies } from './CommercialFamilies';

const AddPromotedCommercialFamily = ({ promotion, setPromotion }: Readonly<ByReferencesProps>) => {
  const renderDiscount = !isFlashPromotion(promotion.promotionType) && promotion.promotionType !== 'BANNER';

  return (
    <Flex direction={'row'}>
      <CommercialFamilies promotion={promotion} setPromotion={setPromotion} />
      <Flex />
      {renderDiscount && <ApplyDiscountCommercialFamily promotion={promotion} setPromotion={setPromotion} />}
    </Flex>
  );
};

export default AddPromotedCommercialFamily;
